import { QuestionCircleOutlined } from '@ant-design/icons'
import { Col, Form, Row, Select, Tooltip } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { Editor } from '@/components'
import { removeHtmlTag } from '@/utils/remove-html-tag'

import { Production, Stage } from '../production.schema'
import { ProductionFormInputMaxCount } from './util'

export const ProductionBackgroundForm: React.FC<{
  production?: Production
}> = ({ production }) => {
  const { t } = useTranslation()

  return (
    <>
      <div className='text-base font-bold mb-4'>{t('production.detail.projectBackground')}</div>
      <Row>
        <Col span={24}>
          {/* 历史的 "项目背景" 映射到当前 "项目动机" */}
          <Form.Item
            valuePropName='content'
            label={
              <>
                <span>{t('production.detail.intention')}</span>
                <Tooltip title={t('production.detail.intentionDescription')}>
                  <QuestionCircleOutlined className='ml-4px text-gray-500' />
                </Tooltip>
              </>
            }
            name='background'
            trigger='onChange'
            rules={[
              {
                required: true,
                validator: async (_, value) =>
                  !removeHtmlTag(value).trim()
                    ? Promise.reject(`${t('production.detail.intention')}是必选填项!`)
                    : Promise.resolve(),
              },
            ]}
          >
            <Editor
              textMaxCount={ProductionFormInputMaxCount}
              className={'editorBorder'}
              placeholder={t('production.detail.intentionDescription')}
              disableAutoSaveStyle
            />
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item
            valuePropName='content'
            label={
              <>
                <span>{t('production.detail.requirement')}</span>
                <Tooltip title={t('production.detail.requirementDescription')}>
                  <QuestionCircleOutlined className='ml-4px text-gray-500' />
                </Tooltip>
              </>
            }
            name='requirement'
            trigger='onChange'
            rules={[
              {
                required: true,
                validator: async (_, value) =>
                  !removeHtmlTag(value).trim()
                    ? Promise.reject(`${t('production.detail.requirement')}是必选填项!`)
                    : Promise.resolve(),
              },
            ]}
          >
            <Editor
              textMaxCount={ProductionFormInputMaxCount}
              className={'editorBorder'}
              placeholder={t('production.detail.requirementDescription')}
              disableAutoSaveStyle
            />
          </Form.Item>
        </Col>
        <Col span={24} className='px-2.5'>
          <div className='mb-2'>
            {t('production.detail.situation')}
            <Tooltip title={t('production.detail.situationAnalysis')}>
              <QuestionCircleOutlined className='ml-4px text-gray-500' />
            </Tooltip>
          </div>
          <Row className='px-2'>
            <Col span={24}>
              <Form.Item
                label={t('production.detail.productionStage')}
                required
                name='stage'
                rules={[{ required: true }]}
              >
                {/* t('Alpha'), t('Beta'), t('Mature') */}
                <Select
                  disabled={!!production}
                  placeholder={t('production.detail.productionStage')}
                  options={Object.entries(Stage).map(([, value]) => ({
                    value,
                    label: t(`production.stage.${value}`),
                  }))}
                ></Select>
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                valuePropName='content'
                label={
                  <>
                    <span>{t('production.detail.situationDescription')}</span>
                    <Tooltip title={t('production.detail.situationDescriptionDescription')}>
                      <QuestionCircleOutlined className='ml-4px text-gray-500' />
                    </Tooltip>
                  </>
                }
                name='situationDescription'
                trigger='onChange'
                rules={[
                  {
                    required: true,
                    validator: async (_, value) =>
                      !removeHtmlTag(value).trim()
                        ? Promise.reject(`${t('production.detail.situationDescription')}是必选填项!`)
                        : Promise.resolve(),
                  },
                ]}
              >
                <Editor
                  textMaxCount={ProductionFormInputMaxCount}
                  placeholder={t('production.detail.situationDescriptionDescription')}
                  className={'editorBorder'}
                  disableAutoSaveStyle
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                valuePropName='content'
                label={
                  <>
                    <span>{t('production.detail.competition')}</span>
                    <Tooltip title={t('production.detail.competitionDescription')}>
                      <QuestionCircleOutlined className='ml-4px text-gray-500' />
                    </Tooltip>
                  </>
                }
                name='competition'
                trigger='onChange'
                rules={[
                  {
                    required: true,
                    validator: async (_, value) =>
                      !removeHtmlTag(value).trim()
                        ? Promise.reject(`${t('production.detail.competition')}是必选填项!`)
                        : Promise.resolve(),
                  },
                ]}
              >
                <Editor
                  textMaxCount={ProductionFormInputMaxCount}
                  placeholder={t('production.detail.competitionDescription')}
                  className={'editorBorder'}
                  disableAutoSaveStyle
                />
              </Form.Item>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  )
}
